import { useQuery } from '@tanstack/react-query'

import type { GcpCert } from '../../types/gcpCert'
import api from '../../api'

const useGcpCerts = () => {
	return useQuery({
		queryKey: ['gcpCerts'],
		queryFn: () => api.gcpCerts.getCerts(),
		select(data) {
			return data.body as Array<GcpCert>
		}
	})
}

export default useGcpCerts